export const SET_DRAWER_MENU_STATE = 'app/DrawerMenu/SET_DRAWER_MENU_STATE';
